import { createFileRoute } from '@tanstack/react-router'

import { MerchantNotesScreen } from './-components/merchant-notes-screen.tsx'

export const Route = createFileRoute('/cs-tools/merchant-notes')({
  component: MerchantNotesScreen
})
